import { Component, OnInit } from "@angular/core";
// import { CAPService } from "../../core/services/cap-service";
// import * as $ from "jquery";


@Component({
  selector: "app-manageaccess",
  templateUrl: "./manageaccess.component.html",
  styleUrls: ["./manageaccess.component.css"],
})
export class ManageaccessComponent implements OnInit {
  AccessTypeList;
  AccessType;
  userAccessFlag:boolean  = false;
  groupAccessFlag:boolean  = false;
  public Role = "";
  
  constructor(
    // private capservice: CAPService
    ) {
    // this.Role = capservice.Role;
  }

  ngOnInit(): void {
    this.AccessTypeList = [
      // { name: 'Skype', },
      { name: "User Access" },
      { name: "Group Access" },
    ];
  }

  AccessTypeEvent(event: any) {
    // if(this.Role =="Regional Voice Admin" || this.Role =="Global Admin")
    // {
    //   $("#AlertForAccess").css("display", "none");
    this.AccessType = event.target.value;
    if (this.AccessType == "User Access") 
    {
      this.userAccessFlag = true;
      this.groupAccessFlag = false;
    } else if (this.AccessType == "Group Access") 
    {
      this.groupAccessFlag = true;
      this.userAccessFlag = false;
    }
  }
  // else{
  //   $("#AlertForAccess").css("display", "block");
  // }
//   }
// }
}
